module.exports = __webpack_public_path__ + "static/media/linux-tux.2e82d079.svg";